import { type ReactNode } from 'react';
import styled from 'types/theme.types';
import { TooltipEllipsisText } from 'components/common/tooltip-ellipsis-text';

interface PopoverTreeLabelProps {
  icon: ReactNode;
  text: string;
  onClick?: (e: React.MouseEvent) => void;
  'data-e2e'?: string;
}

const PopoverTreeLabel = ({ icon, text, onClick, 'data-e2e': dataE2e }: PopoverTreeLabelProps) => {
  return (
    <LabelContent onClick={onClick} data-e2e={dataE2e}>
      {icon}
      <LabelText>
        <TooltipEllipsisText text={text}></TooltipEllipsisText>
      </LabelText>
    </LabelContent>
  );
};

const LabelText = styled.span`
  font-size: 14px;
  /* Figma's UI & Labels / Label Medium. */
  font-weight: var(--type-weight-label);
  color: var(--text-heading);
  padding: 0 var(--padding-xxxs);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  cursor: pointer;
  margin-top: 1px;
`;

const LabelContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  /* The wrapping Button owns the box. Declaring one here too painted a second, smaller box inside it
     with its own hover. Only the internal rhythm belongs here: Figma's 2px between siblings. */
  gap: var(--spacing-xxxxs);
`;

export default PopoverTreeLabel;
